import { PDFViewer } from '@/shared/ui/components';
import type { BillingReferenceProps } from './billingReference.types';
import './billingReference.scss';

/**
 * Renders the billing reference tab of the support page. Only mounts when the tab is active and embeds the supplied document in the shared PDF viewer.
 *
 * @param isActive - Whether the billing reference tab is currently selected.
 * @param url - Address of the billing reference PDF.
 * @returns The billing reference tab body, or a falsy value when inactive.
 */
const BillingReference = ({ isActive, url }: BillingReferenceProps) =>
  isActive && (
    <div className="support-tab billing-reference-tab">
      <div className="support-tab__body">
        <PDFViewer url={url} />
      </div>
    </div>
  );

export default BillingReference;
